/* @flow */
import apiRequest from 'lib/apiRequest';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';
import Collection from 'lib/Collection';

export default class ConnectedBankAccounts extends Collection {
  initialize() {
    this.model = ConnectedBankAccount;
  }

  static load() {
    return apiRequest('/payments/connected_bank_accounts', 'GET')
    .then(connectedbankAccounts => ConnectedBankAccounts.fromJSON(connectedbankAccounts));
  }
}



// WEBPACK FOOTER //
// ./src/collections/ConnectedBankAccounts.js